import SideMenu from './components/SideMenu';
import SideMenuLink from './components/SideMenuLink';

export default SideMenu;
export { SideMenuLink };